import React, { useEffect, useMemo, useState } from 'react'
import { CustomModal } from './CustomModal'
import {
    DragDropContext,
    Droppable,
    Draggable,
    DropResult
} from '@hello-pangea/dnd';
import { isBlank } from '../components/commonClass/CommonValidation';
import { ExportExcel } from '../components/commonClass/ExportExcel';

const ExportReport = (props: any) => {
    const { setExportOpen, exportopen, filtercolumns, exportList, excelSheetName, excelFileName } = props;

    const initialListA = useMemo(() => {
        let list: any = filtercolumns?.filter((fil: any) => !isBlank?.includes(fil?.key))?.map((obj: any) => { return { name: obj?.customName || obj?.customName || obj?.name, id: obj?.key || obj?.Key } })
        return [...list];
    }, [filtercolumns])

    const initialListB = useMemo(() => {
        let list: any = []
        return [...list];
    }, [filtercolumns])

    const [listA, setListA] = useState(initialListA);
    const [listB, setListB] = useState(initialListB);
    const [selectAll, setSelectAll] = useState(false);

    const getList = (id: string) => (id === 'listA' ? listA : listB);
    const setList = (id: any, items: any) => {
        id === 'listA' ? setListA(items) : setListB(items);
    }

    const handleDragEnd = (result: DropResult) => {
        const { source, destination } = result;
        if (selectAll) setSelectAll(false);

        if (!destination) return;

        if (source.droppableId === destination.droppableId) {
            const items = Array?.from(getList(source?.droppableId));
            const [movedItem] = items?.splice(source?.index, 1);
            items?.splice(destination?.index, 0, movedItem);
            setList(source?.droppableId, items);
        } else {
            const sourceList = Array?.from(getList(source?.droppableId));
            const destList = Array?.from(getList(destination?.droppableId));
            const [movedItem] = sourceList?.splice(source?.index, 1);
            destList?.splice(destination?.index, 0, movedItem);
            setList(source?.droppableId, sourceList);
            setList(destination?.droppableId, destList);
        }
    };

    const handleSelectAllChange = (e: any) => {
        const checked = e.target.checked;
        setSelectAll(checked);

        if (checked && listA.length > 0) {
            setListB([...listB, ...listA]);
            setListA([]);
        }
    };
    const ExportToExcel = () => {
        const dispalyname = listB?.map((el: any) => el?.name);
        const fields = listB?.map((el: any) => el?.id);
        ExportExcel(dispalyname, fields, exportList, excelSheetName, `${excelFileName}.xls`);
    }

    const modlabodyfilter = () => {
        return (
            <div className="mt-2">
                <div className='modal_body_subheader py-2 mt-2'>
                    <div className='text-end me-2'>
                        {/* <button type="button" className="btn btn-second me-2" id="request">Request Export</button> */}
                        <button type="button" className="btn btn-second" disabled={listB?.length === 0} onClick={() => ExportToExcel()} id="export">Export</button>
                    </div>
                </div>
                <div className='modal_body_subbody mt-2 p-2'>
                    <div className='modal_body_subheader my-2'>
                        <div className='row'>
                            <div className='col-6'>
                                <div style={{ padding: '10px' }} >
                                    <h5 className='' >Report Fields</h5>
                                    <div>
                                        <input
                                            id='All'
                                            type="checkbox"
                                            className='form-check-input me-2'
                                            checked={selectAll}
                                            onChange={handleSelectAllChange}
                                        />{' '}
                                        <label htmlFor='All' className="form-label mb-1">Select All</label>
                                    </div>
                                </div>
                            </div>
                            <div className='col-6'>
                                <div style={{ padding: '10px' }}>
                                    <h5 className='text-center'>Export Fields</h5>
                                </div>
                            </div>
                        </div>
                    </div>

                    <DragDropContext onDragEnd={handleDragEnd}>
                        {/* List A */}
                        <div className='row'>
                            <div
                                className='col-6'
                            // style={{ paddingRight: 0 }}
                            >
                                <Droppable droppableId="listA">
                                    {(provided, snapshot) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                            style={{
                                                background: snapshot.isDraggingOver ? '#e0f7fa' : '#f0f0f0',
                                                // background: snapshot.isDraggingOver ? '#e0f7fa' : '#ffffff',
                                                padding: 10,
                                                minHeight: "auto",
                                                borderRadius: 10,
                                                height: "100%",
                                                // paddingRight: 0,
                                            }}
                                        >
                                            {/* <h5>Report Fields</h5> */}
                                            {/* <div style={{ marginBottom: 10 }}>
                                                <input
                                                    id='All'
                                                    type="checkbox"
                                                    className='form-check-input me-2'
                                                    checked={selectAll}
                                                    onChange={handleSelectAllChange}
                                                />{' '}
                                                <label htmlFor='All' className="form-label mb-1">Select All</label>
                                            </div> */}
                                            {listA.map((item: any, index: any) => (
                                                <Draggable
                                                    key={item.id}
                                                    draggableId={item.id}
                                                    index={index}
                                                >
                                                    {(provided, snapshot) => (
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            style={{
                                                                userSelect: 'none',
                                                                padding: 5,
                                                                margin: '0 0 5px 0',
                                                                textAlign: 'center',
                                                                alignContent: 'center',
                                                                // padding: 5,
                                                                // margin: '0 0 -5px 0',
                                                                // border: "3px solid #AD704659",
                                                                // height: '40px',
                                                                background: snapshot.isDragging
                                                                    ? '#4dd0e1'
                                                                    : '#ffffff',
                                                                borderRadius: 3,
                                                                boxShadow: snapshot.isDragging
                                                                    ? '0 2px 10px rgba(0,0,0,0.2)'
                                                                    : 'none',
                                                                ...provided.draggableProps.style
                                                            }}
                                                        >
                                                            {item.name}
                                                        </div>
                                                    )}
                                                </Draggable>
                                            ))}
                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Droppable>
                            </div>

                            {/* List B */}
                            <div
                                className='col-6'
                            // style={{ paddingLeft: 0 }}
                            >
                                <Droppable droppableId="listB">
                                    {(provided, snapshot) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                            style={{
                                                background: snapshot.isDraggingOver ? '#e0f7fa' : '#f0f0f0',
                                                // background: snapshot.isDraggingOver ? '#e0f7fa' : '#ffffff',
                                                padding: 10,
                                                minHeight: 300,
                                                borderRadius: 10,
                                                height: "100%",
                                                // paddingLeft: 0
                                            }}
                                        >
                                            {/* <h5>Export Fields</h5> */}
                                            {listB.map((item: any, index: any) => (
                                                <Draggable key={item.id} draggableId={item.id} index={index}>
                                                    {(provided, snapshot) => (
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            style={{
                                                                userSelect: 'none',
                                                                padding: 5,
                                                                margin: '0 0 5px 0',
                                                                textAlign: 'center',
                                                                alignContent: 'center',
                                                                // padding: 5,
                                                                // margin: '0 0 -5px 0',
                                                                // border: "3px solid #AD704659",
                                                                // height: '40px',
                                                                background: snapshot.isDragging
                                                                    ? '#4dd0e1'
                                                                    : '#ffffff',
                                                                borderRadius: 3,
                                                                boxShadow: snapshot.isDragging
                                                                    ? '0 2px 10px rgba(0,0,0,0.2)'
                                                                    : 'none',
                                                                ...provided.draggableProps.style
                                                            }}
                                                        >
                                                            {item.name}
                                                        </div>
                                                    )}
                                                </Draggable>
                                            ))}
                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Droppable>
                            </div>
                        </div>
                    </DragDropContext>
                </div>
            </div>
        )
    }
    return (
        <CustomModal
            {...props}
            show={exportopen}
            size='lg'
            onHide={() => setExportOpen(false)}
            modaltitle='Export Fields'
            modalbody={modlabodyfilter}
            modalfooter=''
        />
    )
}

export default ExportReport